import { useState } from "react";
import { useForm } from "@mantine/form";
import {
  Alert,
  Container,
  PasswordInput,
  Text,
  Paper,
  Group,
  Button,
  Stack,
} from "@mantine/core";
import { useStore } from "../store";
import { userConfirmation } from "./authApi";
import { IconInfoCircle } from "@tabler/icons-react";

export default function Confirmation({ welcomeMessage, params }) {
  const [isFetching, setIsFetching] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const authToken = useStore((state) => state.authToken);
  const userLoggedIn = useStore((state) => state.userLoggedIn);

  if (authToken) {
    return (
      <Container size="sm" mt="xl">
        <Paper radius="md" p="xl" withBorder>
          <Text size="lg" fw={500}>
            You are already logged in
          </Text>
        </Paper>
      </Container>
    );
  }

  const form = useForm({
    initialValues: {
      token: params.token,
      password: "",
    },
    validate: {
      password: (val) =>
        val.length < 8 ? "Password must contain at least 8 characters" : null,
    },
  });

  const errorIcon = <IconInfoCircle />;

  return (
    <Container size="sm" mt="xl">
      {errorMessage && (
        <Alert
          variant="light"
          color="red"
          title="Account Activation Failed"
          mb="lg"
          icon={errorIcon}
        >
          {errorMessage}
        </Alert>
      )}

      <Paper radius="md" p="xl" withBorder>
        <Text size="lg" fw={500}>
          {welcomeMessage || "Set a password for your account"}
        </Text>
        <Text size="md" mt="lg" mb="lg">
          Please set a password to confirm and activate your account!
        </Text>

        <form
          onSubmit={form.onSubmit((values) => {
            console.debug("values: ", values);
            setIsFetching(true);
            setErrorMessage(null);

            userConfirmation(values)
              .then((data) => {
                setIsFetching(false);
                userLoggedIn(data);
              })
              .catch((err) => {
                console.debug("Register Error", err);
                setIsFetching(false);
                setErrorMessage("" + err);
              });
          })}
        >
          <Stack>
            <PasswordInput
              required
              disabled={isFetching}
              label="Password"
              placeholder="Choose a new password"
              value={form.values.password}
              onChange={(event) =>
                form.setFieldValue("password", event.currentTarget.value)
              }
              error={form.errors.password}
              radius="md"
            />
          </Stack>

          <Group justify="space-between" mt="xl">
            <Button type="submit" radius="xl" loading={isFetching}>
              Set Password
            </Button>
          </Group>
        </form>
      </Paper>
    </Container>
  );
}
